
import { Checkbox } from 'antd';

function CheckboxTable({ name, checked, setChecked }) {
  return (
    <>
      <Checkbox
        style={{ marginRight: 10 }}
        checked={checked}
        onChange={() => setChecked(!checked)}
      />
      <span>{name}</span>
    </>
  );
}

export default CheckboxTable;
